export default "__VITE_ASSET__Bn43WPEZ__"